export const COIN_LIME = 'LIME';
export const COIN_USDT = 'USDT';
export const COIN_BTC = 'BTC';
export const COIN_ETH = 'ETH';
export const COIN_BNB = 'BNB';
export const COIN_BUSD = 'BUSD';
export const COIN_USDC = 'USDC';
export const COIN_MATIC = 'MATIC';
